var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4660:158389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.400024 18.4L10 1.7724L19.6 18.4H0.400024Z",
    stroke: "#F79708",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4884 14.7832C10.5748 14.7832 10.6312 14.8408 10.6312 14.9268V15.974C10.6312 16.06 10.5744 16.1176 10.4884 16.1176H9.5128C9.4268 16.1176 9.3692 16.0604 9.3692 15.974V14.9268C9.3692 14.8408 9.4272 14.7832 9.5128 14.7832H10.4884ZM10.4592 7.562C10.5452 7.562 10.6024 7.6196 10.6024 7.7056V13.4904C10.6024 13.5764 10.5452 13.634 10.4592 13.634H9.5412C9.4548 13.634 9.3976 13.5764 9.3976 13.4904V7.7056C9.3976 7.6196 9.4552 7.562 9.5412 7.562H10.4592Z",
    fill: "#F79708"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4660:158389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning-yellow.e1142d2ae3d71b3e818343482c7d4e53.svg";
export { ForwardRef as ReactComponent };